import { api, ApiRequestConfig } from '../../../api';

type FetchServices = {
	storeCode: string;
	categoryId: string;
};
export const fetchServices = (url: string, params: FetchServices, config?: ApiRequestConfig) =>
	api.get(url, params, config);
